import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { useHistory } from 'react-router-dom';

import {
  downloadMessage,
  unAutorizedError,
  errorMessage,
} from 'constants/pop-up-messages';
import { canvasQuiz } from 'screens/career-canvas/career-canvas.constants';
import { getCareerCanvasCsv } from 'services/quiz.service';
import { PROMISES_AREA } from 'constants/promises-area';
import { ROUTES } from 'constants/routes';

export const useDownloadCanvasCsv = () => {
  const { push } = useHistory();

  const downloadCsv = async (email?: string) => {
    try {
      const { data } = await trackPromise(
        getCareerCanvasCsv({
          quizId: canvasQuiz.id,
          email,
        }),
        PROMISES_AREA.getCareerCanvasCsv
      );

      const addEmail = email ? `-${email}` : '';

      downloadMessage(
        `data:application/csv;base64,${data.file}`,
        `${canvasQuiz.title}${addEmail}.csv`,
        undefined,
        'Do you want to download the file?'
      ).fire();
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 401) {
          return unAutorizedError()
            .fire()
            .finally(() => push(ROUTES.signIn));
        }

        return errorMessage(error?.response?.data.message).fire();
      }
    }
  };

  return { downloadCsv };
};
